import { Hero } from "../Components/Hero/Hero"
import { Solutions } from "../Components/Solutions/Solutions"
import { Nav } from "./Nav"

export const Home = () => {

    // const fetchData = () => {
    //     fetch(`http://localhost:${import.meta.env.VITE_PORT}/`)
    //         .then(response => response.text())
    //         .then(data => setMessage(data))
    //         .catch(error => console.error('Error fetching data:', error))
    // }


    return (
        <>
            <Nav />
            <div className="flex h-screen flex-col justify-top items-center gap-4">
                <Hero />
            </div>
            <div className="flex h-screen flex-col justify-top items-center gap-4">
                <Solutions />
            </div>
        </>
    )
}